import { HttpBackend } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { CfgService } from "src/app/cfg/cfg.service";
import { ServerAddressesCfgService } from "src/app/util/serverAddressesCfg.service";

export class VacanciesCfg {
  public summaryEndpointPattern: string;
  public detailEndpointPattern: string;
}

export class VacanciesKpiCfg {
  public vacancies: VacanciesCfg;
  public urlTalent: string;
  public iconUrl: string;
}

@Injectable()
export class VacanciesKpiCfgService extends CfgService<VacanciesKpiCfg> {
  json: any = {
    vacancies: {
      summaryEndpointPattern: "%{DashboardApiUrl}/vacancies/{0}",
      detailEndpointPattern: "%{DashboardApiUrl}/vacancies/{0}/detail"
    },
    urlTalent: "%{TalentApiUrl}/#/",
    iconUrl: "assets/dashboard/vacancy.png"
  }

  constructor(httpBackend: HttpBackend, private serverAddressesCfgService: ServerAddressesCfgService) {
    super(httpBackend);
  }

  protected getCfgFile(): string {
    return `/cfg/kpi/vacanciesKpi.cfg.json`;
  }

  /**
  * Carga las url en el json
  */
  loadDataUrl() {
    this.replacePlaceholders(this.json, this.serverAddressesCfgService.getData());
  }
}
